/**
 * RangedDate
 */

export class RangedDate {
  constructor(
    private dateRange: (Date | null)[] | null,
  ) {
  }

  get dataDe(): Date | null {
    return this.dateRange && this.dateRange.length > 0
      ? (this.dateRange[0] ?? null)
      : null;
  }

  get dataAte(): Date | null {
    return this.dateRange && this.dateRange.length > 1
      ? (this.dateRange[1] ?? null)
      : null;
  }
}